import type { TRuleWithTheme } from '@/styles/theme';

export const field: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '0.5rem',

    // Fixed height rather than vertical padding: the 24px copy icon plus 8px padding and the 1px
    // border would add up to 42px, while the design draws the field at 40px with the stroke inside.
    height: '2.5rem',

    paddingLeft: '0.75rem',
    paddingRight: '0.5rem',

    backgroundColor: theme.colors.inputsBackground,
    border: `1px solid ${theme.colors.inputsBorder}`,
    borderRadius: '0.25rem',

    overflow: 'hidden',
});

export const fieldText: TRuleWithTheme = () => ({
    flex: 1,
    minWidth: 0,

    lineHeight: '1.125rem',

    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

export const baseUrl: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '0.5rem',

    width: '100%',
});
